import { css } from "styled-components";
import { DefaultInputStateCss, ErrorInputStateCss, DisabledInputStateCss } from "./sharedStyles";


export const noHoverdefaultInputWrapperCss = css`
    ${DefaultInputStateCss.base.container}
    &:focus-within {
        ${DefaultInputStateCss.focus}
    }
    &:active {
        ${DefaultInputStateCss.active}
    }    
    & input, textarea, select {
        ${DefaultInputStateCss.base.text};
    }
    & input::placeholder, textarea::placeholder {
        ${DefaultInputStateCss.base.placeholderText};
    }
    `;

export const defaultInputWrapperCss = css`
    ${noHoverdefaultInputWrapperCss}
    &:hover{
        ${DefaultInputStateCss.hover}
    }
`;

export const errorStateInputWrapperCss = css`
    ${ErrorInputStateCss.base.container}
    &:hover{
        ${ErrorInputStateCss.hover}
    }
    &:focus-within {
        ${ErrorInputStateCss.focus}
    }
    &:active {
        ${ErrorInputStateCss.active}
    }    
    & input, textarea, select {
        ${ErrorInputStateCss.base.text};
    }
    & input::placeholder, textarea::placeholder {
        ${ErrorInputStateCss.base.placeholderText};
    }
`;
export const disabledInputWrapperCss = css`
    ${DisabledInputStateCss.container}
    & input, textarea, select {
        ${DisabledInputStateCss.text};
    }
    & input::placeholder, textarea::placeholder {
        ${DisabledInputStateCss.placeholderText};
    }
`;